import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-sidenav-toggle-btn',
  templateUrl: './sidenav-toggle-btn.component.html',
  styleUrls: ['./sidenav-toggle-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavToggleBtnComponent implements OnChanges {
  icon = 'arrow_left';
  @Input() offset = 0;
  @Input() isOpen = false;
  constructor() {}

  ngOnChanges(changes) {
    this.icon = this.getIcon(this.isOpen);
  }

  getClasses() {
    return {
      'sidenav-toggle-btn-close': this.isOpen,
      'sidenav-toggle-btn-open': !this.isOpen
    };
  }

  getStyles() {
    return { 'left.px': this.offset };
  }

  getIcon(open: boolean) {
    return open ? 'arrow_left' : 'arrow_right';
  }
}
